export default __webpack_public_path__ + "static/media/06.9e6e35b2.png";